dmx.Component('rellax', {

  render: function(node) {
    this.$node = node;
    this.$parse();
    
    this.rellax = new Rellax(node);
  },

  beforeDestroy: function() {
    this.rellax.destrow();
  }

});
